<template>
  <div class="proposal-container bg-pink text-center position-relative overflow-hidden">
    <!-- Floating hearts -->
    <div
        v-for="(style, index) in heartStyles"
        :key="index"
        class="floating-heart"
        :style="style"
    >💖</div>

    <!-- Confetti -->
    <div v-if="decisionMade" class="confetti-container">
      <div v-for="n in 400" :key="n" class="confetti" :style="{ '--i': n }"></div>
    </div>

    <!-- Final message box -->
    <div v-if="decisionMade" class="final-message d-flex justify-content-center align-items-center">
      <div class="final-bg-image-container">
        <img
            v-for="(img, i) in finalImages"
            :key="i"
            :src="img"
            class="final-bg-image"
            :style="randomImageStyle()"
        />
      </div>

      <div class="message-box">
        <div class="fs-3 fw-bold mb-3" v-html="finalMessageHtml"></div>
      </div>
    </div>

    <!-- Main content -->
    <div v-else class="d-flex flex-column justify-content-center align-items-center min-vh-100">
      <h1 class="display-3 fw-bold mb-2">Willst du meine Freundin sein? 🥺💕</h1>
      <p class="fw-bold mb-5">Bitte stellen Sie sicher, diese Frage nur dann zu beantworten, wenn Sie sich wirklich bereit dafür fühlen.</p>

      <div class="d-flex flex-column align-items-start gap-4 fs-3">
        <div class="form-check form-check-lg">
          <input class="form-check-input big-checkbox" type="checkbox" id="yes" @change="handleYes">
          <label class="form-check-label ms-2" for="yes">Ja 💖</label>
        </div>

        <div class="form-check form-check-lg">
          <input class="form-check-input big-checkbox" type="checkbox" id="no" @click.prevent="handleNo">
          <label class="form-check-label ms-2" for="no">Nein 😢</label>
        </div>

        <div class="form-check form-check-lg">
          <input class="form-check-input big-checkbox" type="checkbox" id="maybe" @change="handleMaybe">
          <label class="form-check-label ms-2" for="maybe">Vielleicht 🤔</label>
        </div>
      </div>

      <p v-if="noText" class="mt-4 text-danger fw-semibold fs-4">{{ noText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      noText: '',
      decisionMade: false,
      finalMessageHtml: '',
      finalImages: [],
      availableImages: [
        'https://media.giphy.com/media/3o6ZtaO9BZHcOjmErm/giphy.gif',
        'https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif',
        'https://media.giphy.com/media/26AHONQ79FdWZhAI0/giphy.gif',
        'https://media.giphy.com/media/l0HlJzQXzvDQzsGOk/giphy.gif',
        'https://media.giphy.com/media/3o7aD4YyKkPjR3y5c4/giphy.gif',
        'https://placekitten.com/400/300',
        'https://placebear.com/400/300',
        'https://picsum.photos/400/300?random=1',
        'https://picsum.photos/400/300?random=2',
        'https://media.tenor.com/8LQxKnQUPmcAAAAC/peach-goma.gif'
      ],
      heartStyles: [],
      noReasons: [
        "Aber ich hab doch Kekse! 🍪", "Ich hab mir so viel Mühe gegeben... 😭",
        "Meine Katze wird traurig sein. 🐹", "Nein ist keine Option! ❌",
        "Du brichst mein Herz! 💔", "Ich hab extra eine Website gemacht! 💻",
        "Ich hab Blumen! 🌸",
        "Bitte nicht Nein... 😢", "Willst du mich wirklich so traurig sehen? 😞",
        "Ich bin sensibel, ok? 😳", "Aber... aber... ich hab dich doch lieb! 😍",
        "Das ist illegal in 37 Ländern! ⚖️", "Ich hab einen Kuchen gebacken! 🎂",
        "Ein Nein macht die Welt ein bisschen trauriger... 🌧️",
        "Ich hab mein Zimmer aufgeräumt! 🧹", "Ich hab sogar Deo benutzt! 😅",
        "Ich schreib dir auch jeden Morgen ein Gedicht! ✍️",
        "Ich kann kochen! Naja, fast... 🍝", "Selbst meine Eltern fragen nach dir! 👵",
        "Ein Nein tut mehr weh als Lego unter dem Fuß! 🦶",
        "Ich hab extra mein Lieblingsshirt angezogen! 👕", "Selbst Disney würde das nicht so traurig machen... 🏰",
        "Das ist schlimmer als kein WLAN! 📶", "Aber wir passen so gut zusammen! 💑",
        "Einfach Ja sagen, es tut nicht weh! 😇", "Wenn du Nein sagst, stirbt ein Einhorn. 🦄"
      ]
    };
  },
  created() {
    const styles = [];
    for (let i = 0; i < 30; i++) {
      const top = Math.random() * 100;
      const left = Math.random() * 100;
      const duration = 10 + Math.random() * 10;
      const size = 1 + Math.random() * 2;
      const delay = Math.random() * 10;
      styles.push({
        top: `${top}vh`,
        left: `${left}vw`,
        fontSize: `${size}rem`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      });
    }
    this.heartStyles = styles;
  },
  mounted() {
    const nav = document.querySelector('nav');
    const footer = document.querySelector('footer');
    if (nav) nav.remove();
    if (footer) footer.remove();
  },
  methods: {
    handleYes() {
      this.finalMessageHtml = `
        <p>Eine <strong>großartige Entscheidung</strong>! 🥳</p>
        <p>Bitte setzen Sie Herrn Max Schlosser (M.Sc. und <a href="https://schlosser.dev/book" target="_blank">Fachbuchautor</a>) in Kenntnis,
        damit weitere Schritte diskutiert werden können.</p>
      `;
      this.decisionMade = true;
      this.$nextTick(this.launchConfetti);
    },
    handleMaybe() {
      this.finalMessageHtml = `
        <p>Vielleicht ist quasi ein Ja.</p>
        <p>Eine <strong>großartige Entscheidung</strong>! 🥳</p>
        <p>Bitte setzen Sie Herrn Max Schlosser (M.Sc. und <a href="https://schlosser.dev/book" target="_blank">Fachbuchautor</a>) in Kenntnis,
        damit weitere Schritte diskutiert werden können.</p>
      `;
      this.decisionMade = true;
      this.$nextTick(this.launchConfetti);
    },
    handleNo(event) {
      event.preventDefault();
      const randomIndex = Math.floor(Math.random() * this.noReasons.length);
      this.noText = this.noReasons[randomIndex];
      this.shakeScreen();
    },
    shakeScreen() {
      const body = document.body;
      body.classList.add('shake');
      setTimeout(() => body.classList.remove('shake'), 600);
    },
    launchConfetti() {
      const confetti = document.querySelectorAll('.confetti');
      confetti.forEach(el => {
        const x = Math.random() * 100;
        const y = Math.random() * 100;
        const rotate = Math.random() * 360;
        const delay = Math.random() * 2;
        const duration = 3 + Math.random() * 2;

        el.style.left = `${x}vw`;
        el.style.top = `${y - 100}vh`;
        el.style.transform = `rotate(${rotate}deg)`;
        el.style.animationDelay = `${delay}s`;
        el.style.animationDuration = `${duration}s`;
      });
    }
  }
};
</script>

<style scoped>
/* Layout and background */
.bg-pink {
  background-color: #f9a8d4;
}
html, body {
  height: 100%;
  margin: 0;
  overflow-x: hidden;
}

/* Final message box */
.final-message {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: #fff0f6;
}
.message-box {
  padding: 2rem;
  margin: 0 1rem;
  border-radius: 1rem;
  background: white;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
  background-color: #f9a8d4;
}

/* Shake animation */
@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}
.shake {
  animation: shake 0.6s;
}

/* Checkbox styling */
.big-checkbox {
  width: 2rem;
  height: 2rem;
}

/* Floating hearts */
.floating-heart {
  position: absolute;
  animation-name: floatRandom;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  opacity: 0.6;
  pointer-events: none;
}
@keyframes floatRandom {
  0% {
    transform: translate(0, 0) scale(1) rotate(0deg);
    opacity: 0.6;
  }
  25% {
    transform: translate(20px, -30px) scale(1.2) rotate(15deg);
  }
  50% {
    transform: translate(-20px, -60px) scale(1.4) rotate(-10deg);
    opacity: 1;
  }
  75% {
    transform: translate(30px, -90px) scale(1.1) rotate(10deg);
  }
  100% {
    transform: translate(0px, -120px) scale(1.3) rotate(0deg);
    opacity: 0;
  }
}

/* Confetti effect */
.confetti-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  pointer-events: none;
  z-index: 99999;
}

.confetti {
  position: absolute;
  width: 10px;
  height: 20px;
  background-color: hsl(calc(360 * var(--i) / 100), 70%, 60%);
  animation-name: confetti-fall;
  animation-timing-function: ease-out;
  animation-iteration-count: 1;
  opacity: 0.8;
  will-change: transform, top;
}

@keyframes confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(120vh) rotate(360deg);
    opacity: 0;
  }
}

a {
  text-decoration: underline !important;
}
</style>

<style>
@keyframes shake {
  0%   { transform: translate(1px, 1px) rotate(0deg); }
  10%  { transform: translate(-1px, -2px) rotate(-1deg); }
  20%  { transform: translate(-3px, 0px) rotate(1deg); }
  30%  { transform: translate(3px, 2px) rotate(0deg); }
  40%  { transform: translate(1px, -1px) rotate(1deg); }
  50%  { transform: translate(-1px, 2px) rotate(-1deg); }
  60%  { transform: translate(-3px, 1px) rotate(0deg); }
  70%  { transform: translate(3px, 1px) rotate(-1deg); }
  80%  { transform: translate(-1px, -1px) rotate(1deg); }
  90%  { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

.shake {
  animation: shake 0.6s;
}

.final-bg-image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.final-bg-image {
  position: absolute;
  animation: floatY 10s ease-in-out infinite;
}

@keyframes floatY {
  0% { transform: translateY(0) scale(1) rotate(0deg); }
  50% { transform: translateY(-20px) scale(1.1) rotate(5deg); }
  100% { transform: translateY(0) scale(1) rotate(-5deg); }
}
</style>
